<script lang="ts">
    // BOTÃO DE AÇÃO FLUTUANTE (mobile)
    //
    // A ação principal da tela no celular — "Agendar" na agenda, "Nova venda" no PDV. Fica ancorado no
    // canto inferior direito, acima da barra de navegação, e acompanha duas coisas:
    //   1. a barra inferior do app (store mobileBarVisible): quando ela some, o botão desce junto;
    //   2. o fim da rolagem: chegando ao fim da lista ele some, para não cobrir os botões do último item.
    //      Se o conteúdo nem rola, não há o que descobrir — ele fica.
    //
    // É peça de celular: acima de 900px ele não aparece (a tela põe a mesma ação no Zact ou nos acts do
    // grid). O botão "Agendar" da agenda tem a sua própria cópia disso dentro do schedules-container,
    // porque lá o mesmo bloco é botão comum no desktop e flutuante no mobile.
    import { onDestroy, onMount } from 'svelte'
    import type { IconDefinition } from '@fortawesome/free-solid-svg-icons'
    import Zbutton from './zbutton.svelte'
    import { mobileBarVisible } from '../stores'

    export let label: string = ''
    export let icon: IconDefinition = null
    export let color: 'green' | 'red' | 'yellow' | 'secondary' | 'primary' = 'primary'
    /** esconde o botão sem tirar da tela (ex.: enquanto um painel está aberto por cima) */
    export let hidden: boolean = false
    export let disabled: boolean = false
    let className: string = ''
    export { className as class }

    let atEnd = false

    // a rolagem pode acontecer em qualquer contêiner da tela, por isso o listener é de captura no
    // documento — mesmo caminho que a barra inferior usa para se esconder (ver template-mobile).
    function onScroll(event: Event) {
        const target: any = event.target
        const el: HTMLElement = target === document || target === window ? (document.scrollingElement as HTMLElement) : target
        if (!el || typeof el.scrollHeight !== 'number') return
        const rolavel = el.scrollHeight - el.clientHeight > 8
        const restante = el.scrollHeight - el.scrollTop - el.clientHeight
        atEnd = rolavel && restante <= 24
    }

    onMount(() => document.addEventListener('scroll', onScroll, true))
    onDestroy(() => document.removeEventListener('scroll', onScroll, true))
</script>

<div class="zfab {className}" class:is-hidden={hidden || atEnd} class:bar-hidden={!$mobileBarVisible}>
    <Zbutton {color} {icon} {label} {disabled} title={label} on:click />
</div>

<style>
    /* peça de celular: no desktop a ação mora no Zact ou nos acts do grid */
    .zfab {
        display: none;
    }

    @media (max-width: 900px) {
        /* 75px = altura da barra inferior do app (61px) + folga */
        .zfab {
            position: fixed;
            right: 14px;
            bottom: 75px;
            z-index: 4;
            display: flex;
            border-radius: 999px;
            box-shadow: 0px 4px 14px #0000005c;
            transition:
                opacity 0.18s ease,
                transform 0.18s ease,
                bottom 0.1s linear;
        }
        /* barra inferior oculta: desce junto, em vez de flutuar sobre o vazio */
        .zfab.bar-hidden {
            bottom: 14px;
        }
        .zfab.is-hidden {
            opacity: 0;
            transform: translateY(14px);
            pointer-events: none;
        }
        .zfab :global(.zbutton) {
            border-radius: 999px !important;
            height: 48px;
            padding-left: 17px;
            padding-right: 19px;
        }
    }
</style>
